import Page from '../../class/Page';

window.pageCurrent = class extends Page {};
